import { render, staticRenderFns } from "./WxApplyment.vue?vue&type=template&id=719ba2c0&scoped=true"
import script from "./WxApplyment.vue?vue&type=script&lang=js"
export * from "./WxApplyment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ba2c0",
  null
  
)

export default component.exports